import type { ReactNode } from 'react';
import './fonoteka.css';

export function FonotekaScope({ children }: { children: ReactNode }) {
  return <div className="fonoteka-root">{children}</div>;
}
